<template>
  <v-row>
    <v-col class="text-center kbGrayText--text" cols="12">
      <h3>
        {{ title }}
      </h3>
    </v-col>

    <v-col cols="12">
      <v-item-group v-model="importerSelection">
        <v-container fluid>
          <v-row justify="center">
            <v-col
              cols="12"
              md="3"
              v-for="({ icon, title, value }, index) in importationTypes"
              :key="index">
              <v-item :value="value">
                <v-card slot-scope="{ active, toggle }"
                        class="kbWhite text-center"
                        :class="`${color}--text`"
                        :color="active ? color : ''"
                        :dark="!!active"
                        @click="toggle">
                  <v-card-text>
                    <v-icon x-large>
                      {{ icon }}
                    </v-icon>
                    <span class="text-h6 d-block">
                        {{ title }}
                      </span>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-container>
      </v-item-group>
    </v-col>

    <v-col
      class="text-center"
      cols="12"
      v-if="importerSelection === 'existente'"
    >
      <v-row justify="center">
        <v-select v-model="importerListId"
                  color="kbDarkBlueText"
                  :items="listsPersons"
                  item-text="name"
                  item-value="_id"
                  outlined
                  style="max-width: 500px"
                  :no-data-text="$t('general.listsNotCreated')"
                  :label="$t('general.pickAList')"
                  :rules="[rules.required]">
        </v-select>
      </v-row>
    </v-col>

    <v-col
      class="text-center"
      cols="12"
      v-if="importerSelection === 'nueva'"
    >
      <v-row justify="center">
        <v-text-field v-model="importerListName"
                      color="kbDarkBlueText"
                      outlined
                      style="max-width: 500px"
                      :label="$t('general.typeNameOfTheList')"
                      :rules="[rules.required]">
        </v-text-field>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import rules from '@/libs/rules'
export default {
  computed: {
    importationTypes () {
      let importationTypes =
        Array.isArray(this.importationTypesArray)
          ? JSON.parse(JSON.stringify(this.importationTypesArray))
          : []

      const visualizationConditions = [
        this.type !== 'campaigns' && this.sidebarModules.includes('sidebar-business'),
        this.listsPersons.length && this.type !== 'campaigns',
        true,
        this.type !== 'campaigns'
      ]

      importationTypes = importationTypes.filter((item, index) => visualizationConditions[index])

      return importationTypes
    },
    importerListId: {
      get () {
        return this.$store.state.listsPersons.importer.listId
      },
      set (value) {
        this.$store.commit('SET_IMPORTER_LIST_ID', value)
      }
    },
    importerListName: {
      get () {
        return this.$store.state.listsPersons.importer.listName
      },
      set (value) {
        this.$store.commit('SET_IMPORTER_LIST_NAME', value)
      }
    },
    importerSelection: {
      get () {
        return this.$store.state.listsPersons.importer.importerSelection
      },
      set (value) {
        this.$store.commit('SET_IMPORTER_SELECTION', value)
      }
    },
    title () {
      if (this.sidebarModules.includes('sidebar-business')) {
        return this.$t('general.pickToImportBusinessesOrPeopleToNewList', { business: this.businessModule.p })
      } else {
        return this.$t('general.pickToSavePeopleToList', { business: this.businessModule.s })
      }
    }
  },
  data () {
    return {
      importationTypesArray: [
        { active: false, icon: 'mdi-factory', title: this.businessModule.s, value: 'negocio' },
        { active: false, icon: 'check', title: this.$t('general.existentList'), value: 'existente' },
        { active: false, icon: 'add', title: this.$t('general.newList'), value: 'nueva' },
        { active: false, icon: 'clear', title: this.$t('general.noList'), value: 'sin-lista' }
      ],
      rules
    }
  },
  props: {
    businessModule: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      default: 'kbPink'
    },
    listsPersons: {
      type: Array,
      required: true
    },
    sidebarModules: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  }
}
</script>
